export default class HomeBanner {
  image: string;
  url: string;

  constructor(entity: HomeBanner) {
    this.image = entity.image;
    this.url = entity.url;
  }
}



// WEBPACK FOOTER //
// ./src/entities/HomeBanner.tsx